import { isDefined } from '@sgme/fp';

import type { BidAskPoint, BidAskRate } from '@/utils/number-point.ts';

type Paremeters = {
  pinnedNearPrice: BidAskRate | undefined;
  userGivenMarginSpotPoints: BidAskPoint;

  nearNotional: number;
  farNotional: number;
  traderSpotPrice: BidAskRate;
  spot: BidAskRate;
  currencyPairPrecision: number;
};

// Computes the spot margin points effectively used for margin computation
// if the user pinned a near price, then the applied margin spot is deduced from the context (the orther parameters)
// else the margin spot points given by the user is user instead (and this is backed by the default margin spot points values given by the quote)
//
// source excel formula :
// SpotComMarginBidFinal (PPS spot margin) // NB : PPS is meaningfyul in the excel spearsheet, here in FX we are only display in PPS, and state stores values in points
// =SI(PinNearPriceClientBid<>""
//   ;SIGNE(FarNotional-NearNotional)*(SpotPriceTraderBid-SpotPriceClientBid)*10^4
//   ;SpotComMarginBid)
export function computeAppliedMarginSpotDeltaRate({
  pinnedNearPrice,
  userGivenMarginSpotPoints,

  nearNotional,
  farNotional,
  traderSpotPrice,
  spot,
  currencyPairPrecision,
}: Paremeters): BidAskPoint {
  const direction = Math.sign(farNotional - nearNotional);
  return isDefined(pinnedNearPrice)
    ? {
        bid: direction * (traderSpotPrice.bid - spot.bid),
        ask: direction * (spot.ask - traderSpotPrice.ask), // nota bene : inversion regarding bid
      }
    : {
        bid: userGivenMarginSpotPoints.bid * 10 ** -currencyPairPrecision,
        ask: userGivenMarginSpotPoints.ask * 10 ** -currencyPairPrecision,
      };
}
